import { ISelectValues } from "../../../component/ISelectValues";

const COLOR_READY = 'secondary';
const COLOR_ACTIVE = 'warning';
const COLOR_REVOKED = 'error';
const COLOR_CANCELLED = 'default';

export const ID_FILTER_TYPE = "type";
export const ID_FILTER_STATUS = "status";
export const ID_FILTER_DEBTOR_NAME = "debtor-name";
export const ID_FILTER_DEBTOR_IBAN = "debtor-iban";
export const ID_FILTER_SUBSCRIBER_FIRST_NAME = "subscriber-first-name";
export const ID_FILTER_SUBSCRIBER_LAST_NAME = "subscriber-last-name";
export const ID_FILTER_SUBSCRIBER_TAX_CODE = "subscriber-tax-code";
export const ID_FILTER_SUBSCRIPTION_DATE_FROM = "subscription-date-from";
export const ID_FILTER_SUBSCRIPTION_DATE_TO = "subscription-date-to";

export const STATUS_READY = "READY";
export const STATUS_ACTIVE = "ACTIVE";
export const STATUS_REVOKED = "REVOKED";
export const STATUS_CANCELLED = "CANCELLED";

export const TYPES: ISelectValues[] = [
    {
        value: "CORE",
        label: "types.CORE",
        color: COLOR_READY,
    },
    {
        value: "B2B",
        label: "types.B2B",
        color: COLOR_ACTIVE,
    }
];

export const STATUSES: ISelectValues[] = [
    {
        value: "READY",
        label: "statuses.READY",
        color: COLOR_READY,
    },
    {
        value: "ACTIVE",
        label: "statuses.ACTIVE",
        color: COLOR_ACTIVE,
    },
    {
        value: "REVOKED",
        label: "statuses.REVOKED",
        color: COLOR_REVOKED,
    },
    {
        value: "CANCELLED",
        label: "statuses.CANCELLED",
        color: COLOR_CANCELLED,
    }
];
